import { AuthClient } from 'auth'

export const authClient = new AuthClient(true, window.location.origin)
